import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { sessionGetItemStr, sessionGetItemObj } from '../../../utils/sessionHelpers'
import AssetMigrationWidget from '../../../widgets/durableArticlesWidget/assetMigrationWidget/AssetMigrationWidget'
import { getAssetMigration } from '../../../redux/actions/assetMigration'

export default function AssetMigration() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const projectCode = sessionGetItemStr('projectCode')

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getAssetMigration(projectCode)
      //_schema.model.disabled = false // test edit mode
      setSchema(_schema.model)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isIncomeAndExpense>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isIncomeAndExpense>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <div>
      <SidebarProposal isIncomeExpenseApprover>
        <ContentHeader header={schema.header} subHeader={''} isNotCallApi />

        <AssetMigrationWidget schema={schema} />

        <br />
      </SidebarProposal>
    </div>
  )
}

const mock = {
  affectedRows: 0,
  message: null,
  success: true,
  didError: false,
  errorMessage: null,
  model: {
    form: {
      isEnableEdit: true,
      values: [
        {
          id: 'D3C8A0CA-A6B7-411A-A916-503159844698',
          periodNumber: 1,
          assetCode: 'A57-02472-5-001',
          assetName: 'คอมพิวเตอร์ notebook LENOVO ideapad TM 305',
          assetTypeCode: '5',
          assetSerialNo: null,
          assetModel: null,
          assetBillDate: '2016-01-25 00:00:00.000',
          unitPrice: 16990.00,
          totalPrice: 16990.00,
          assetPicturePathFile: 'https://efin.thaihealth.or.th/DurableGoods/60-02041/0601_564_0601_564_0601_564_0601_564_IMG20200817124452.jpg',
          assetBillPathFile: 'https://efin.thaihealth.or.th/DurableGoods/60-02041/0701_564_0701_564_0701_564_0701_564_0001.jpg',
          assetStatusCode: '6',
          projectCode: '62-00131',

          // id: '3AAAA54D-FF16-4909-AEB0-66FD49D578AA',
          // registerDocNo: null,
          // assetBillNo: '1212412',
          // assetCode: null,
          // assetName: '22',
          // assetType: 'ครุภัณฑ์งานบ้านงานครัว',
          // assetStatusCode: '0',
          // assetStatus: 'รอขึ้นทะเบียน',
          // approvedComment: null,
          // assetQrCodePathFile: null,
          // totalPrice: 1,
          // editMessage: null,
          // isEnableEdit: true,
        },
        {
          id: 'D3C8A0CA-A6B7-411A-A916-503159844698',
          periodNumber: 1,
          assetCode: 'A57-02472-5-001',
          assetName: 'คอมพิวเตอร์ notebook LENOVO ideapad TM 305',
          assetTypeCode: '5',
          assetSerialNo: null,
          assetModel: null,
          assetBillDate: '2016-01-25 00:00:00.000',
          unitPrice: 16990.00,
          totalPrice: 16990.00,
          assetPicturePathFile: 'https://efin.thaihealth.or.th/DurableGoods/60-02041/0601_564_0601_564_0601_564_0601_564_IMG20200817124452.jpg',
          assetBillPathFile: 'https://efin.thaihealth.or.th/DurableGoods/60-02041/0701_564_0701_564_0701_564_0701_564_0001.jpg',
          assetStatusCode: '6',
          projectCode: '62-00131',
        },
        {
          id: 'D3C8A0CA-A6B7-411A-A916-503159844698',
          periodNumber: 1,
          assetCode: 'A57-02472-5-001',
          assetName: 'คอมพิวเตอร์ notebook LENOVO ideapad TM 305',
          assetTypeCode: '5',
          assetSerialNo: null,
          assetModel: null,
          assetBillDate: '2016-01-25 00:00:00.000',
          unitPrice: 16990.00,
          totalPrice: 16990.00,
          assetPicturePathFile: 'https://efin.thaihealth.or.th/DurableGoods/60-02041/0601_564_0601_564_0601_564_0601_564_IMG20200817124452.jpg',
          assetBillPathFile: 'https://efin.thaihealth.or.th/DurableGoods/60-02041/0701_564_0701_564_0701_564_0701_564_0001.jpg',
          assetStatusCode: '6',
          projectCode: '62-00131',
        },
      ],
      projectCode: {
        name: 'projectCode',
        label: 'รหัสโครงการ',
        value: null,
        validators: [],
      },
    },
    header: 'Migrate ครุภัณฑ์',
    subHeader: '',
    disabled: false,
    isApprover: false,
  },
}
